import isObject from './is-object.js';
export default function isRecord(value) {
    return isObject(value);
}
//# sourceMappingURL=is-record.js.map